import universal from 'react-universal-component';

export default universal(() => import('./Dynasty'));



// WEBPACK FOOTER //
// ./src/app/views/Dynasty/index.js